import React from "react";
import { TouchableNativeFeedback, View, StyleSheet } from "react-native";
import Checkbox from "@components/Checkbox";
import CustomText from "@components/CustomText";
import color from "@constants/color";
import Plus from "@assets/svg/MyDeliveries/Plus";
import Minus from "@assets/svg/MyDeliveries/Minus";

const LostDamageComponent = ({
  lostDamageCount,
  changeLostDamageCount = () => {},
  can_mark_max_ofd_count,
}) => {
  return (
    <View style={styles.container}>
      <View style={styles.checkBoxContainer}>
        <Checkbox
          tintColors={{ true: color.primary }}
          value={lostDamageCount > 0}
          onChange={() => {
            changeLostDamageCount(lostDamageCount > 0 ? 0 : 1);
          }}
        />
        <CustomText variant="body_text_4" style={styles.checkBoxText}>
          लॉस्ट / डैमेज
        </CustomText>
      </View>
      {lostDamageCount > 0 && (
        <View style={styles.counterContainer}>
          <TouchableNativeFeedback
            testID="subtract"
            onPress={() => {
              changeLostDamageCount(lostDamageCount - 1);
            }}
          >
            <View style={styles.counterButton}>
              <Minus stroke={color.primary} height={12} width={12} />
            </View>
          </TouchableNativeFeedback>
          <CustomText variant="title_16" style={styles.counterText}>
            {lostDamageCount}
          </CustomText>
          <TouchableNativeFeedback
            testID="add"
            disabled={lostDamageCount >= can_mark_max_ofd_count}
            onPress={() => {
              changeLostDamageCount(lostDamageCount + 1);
            }}
          >
            <View style={styles.counterButton}>
              <Plus
                stroke={
                  lostDamageCount >= can_mark_max_ofd_count
                    ? color.darkGrey
                    : color.primary
                }
                height={12}
                width={12}
              />
            </View>
          </TouchableNativeFeedback>
        </View>
      )}
    </View>
  );
};

export default LostDamageComponent;

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  checkBoxContainer: {
    flexDirection: "row",
    alignItems: "center",
    right: 6,
  },
  checkBoxText: {
    color: "#000",
  },
  counterContainer: {
    flexDirection: "row",
    backgroundColor: color.white,
    borderRadius: 8,
    alignItems: "center",
    elevation: 1,
  },
  counterButton: {
    paddingHorizontal: 8,
    paddingVertical: 3,
  },
  counterText: {
    color: color.primary,
    paddingHorizontal: 3,
  },
});
